import { Injectable, Renderer2, RendererFactory2 } from '@angular/core'

@Injectable({ providedIn: 'root' })
export class SchemaService {
  private renderer: Renderer2

  constructor(private rendererFactory: RendererFactory2) {
    this.renderer = this.rendererFactory.createRenderer(null, null)
  }

  addSchema(schemaData: object) {
    this.removeSchema()
    const script = this.renderer.createElement('script')
    script.type = 'application/ld+json'
    script.text = JSON.stringify(schemaData)

    this.renderer.appendChild(document.head, script)
  }

  removeSchema() {
    const existingScripts = document.querySelectorAll('script[type="application/ld+json"]')
    existingScripts.forEach(script => script.parentNode?.removeChild(script))
  }
}
